
export function inputJut() {
	$('form').each(function(i,form) {
		form.reset()
	})

	function handleFocus($this) {
		if ($this.hasClass('hasDatepicker')) return
		$this.closest$$('inputJut').addClass('active')
		$this.closest$$('inputJut').removeClass('inactive')
	}

	function handleBlur($this) {
		if ($this.hasClass('hasDatepicker')) return

		if (!$this.val().length) {
			$this.closest$$('inputJut').removeClass('active')
			$this.closest$$('inputJut').addClass('inactive')
		}
	}

	$(document).on('focus', 'input,select,textarea', function(ev) {
		const $this = $(this)
		const $parent = $this.closest$$('inputJut')
		if (!$parent.length) return
		handleFocus($this)
	})

	$(document).on('blur', 'input,select,textarea', function(ev) {
		const $this = $(this)
		const $parent = $this.closest$$('inputJut')
		if (!$parent.length) return
		handleBlur($this)
	})

	$('form').on('reset', function() {
		const $this = $(this)
		const $juts = $this.find$$('inputJut')
		if (!$juts.length) return

		$juts.each(function(i,elm) {
			const $elm = $(elm)
			const state = $elm.data('state')
			if (state) {
				$elm.removeClass('active inactive')
				$elm.addClass(state)
			}
		})
	})
}

export function fileInput() {
	const component = $('[data-file="file-input"]')
	if (!component.length) return

	const sqFile = (str)=> `[data-file="${str}"]`
	const sqAttr = (attr, str)=> str ? `[${attr}="${str}"]` : `[${attr}]`

	const inputsClones = component.find(sqFile('input')).clone()


	const addInfo = function(elm, str) {
		const infoStr = elm.closest(sqFile('file-input')).find(sqAttr('data-info'))
		infoStr.text( str ? str : infoStr.data('info'))
	};

	const addState = function(elm) {
		elm.find(sqFile('text-pick')).removeClass('hide')
		elm.find(sqFile('text-change')).addClass('hide')
		elm.find(sqFile('delete')).addClass('hide')
	};

	const removeState = function(elm) {
		elm.find(sqFile('text-pick')).addClass('hide')
		elm.find(sqFile('text-change')).removeClass('hide')
		elm.find(sqFile('delete')).removeClass('hide')
	};

	const reset = function(elm) {
		const index = component.index(elm)
		const indexComponent = $(component[index])

		// ie fix reset fileinput
		indexComponent.find(sqFile('input')).remove()
		indexComponent.append(inputsClones[index].outerHTML)

		addInfo(indexComponent)
		addState(indexComponent)
	};

	const events = function() {
		component.on('change', sqFile('input'), function(ev) {
			const _this = $(this)
			const container = _this.closest(sqFile('file-input'))

			if (this.files.length) {
				removeState(container)
				addInfo(_this, this.files[0].name)
			} else {
				addState(container)
				addInfo(_this)
			}
		});

		component.on('click', sqFile('delete'), function(ev) {
			ev.preventDefault()
			reset($(this).closest(sqFile('file-input')))
		});

		component.on('focus', sqFile('input'), function(ev) {
			$(this).closest('label').addClass('form-file-input-focus')
		});

		component.on('blur', sqFile('input'), function(ev) {
			$(this).closest('label').removeClass('form-file-input-focus')
		});
	};

	component.each(function (i,elm) {
		addInfo($(elm))
	});

	events()

	return { reset }
}

export function inputThumb() {
	$('form').on('change', '[data-se="fileInputThumb"]', function readInput() {
		const $this = $(this);
		if (this.files.length) {
			const $this = $(this);
			const reader = new FileReader()
			const $parent = $this.closest('.form-file-thumb')
			$parent.find$$('fileInputThumbDelete').val('')

			reader.readAsDataURL(this.files[0]);
			reader.onload = function (ev) {
				$parent.find('.form-file-thumb-img').attr('style',`background-image: url(${ev.target.result})`)
				$parent.find('.btn').toggleClass('d-n')
			}
		}
	});

	$('form').on('click', '[data-se="fileThumbBtnRemove"]', function() {
		const $this = $(this);
		const $parent = $this.closest('.form-file-thumb')
		const $imgDefault = $parent.find('.form-file-thumb-img')

		$parent.find('.form-file-thumb-img').attr('style',`background-image: url(${$imgDefault.attr('data-src-default')})`)
		$parent.find('.btn').toggleClass('d-n')
		$parent.find$$('fileInputThumb').val('')
		$parent.find$$('fileInputThumbDelete').val('1')
	})
}

export function formSearchFilter(elm, opt) {

	elm = $(elm);
	if (!elm.length) return;

	const toggler  = elm.find(opt.toggler);
	const dpStart  =  elm.find(opt.dpStart);
	const dpEnd    =  elm.find(opt.dpEnd);

	const changeDatepiker = function () {
		var data = toggler.find('option:selected').data('datepicker');
		dpStart.add(dpEnd).prop('disabled', true).val('');

		if (!data) return;

		dpStart.prop('disabled', false);

		data.forEach(function(e) {
			elm.find('[name="'+ e.elm +'"]')
				.datepicker('option', 'maxDate', (e.opt.maxDate || null) )
				.datepicker('option', 'minDate', (e.opt.minDate || null) );
		});
	};

	$(window).on('load', changeDatepiker);

	toggler.change(changeDatepiker);
}

// https://stackoverflow.com/questions/14432571/control-html5-validation-balloon-scroll
export function formInvalidScroll(form) {
	form = form instanceof jQuery ? form : $(form);
	if (!form.length) return;
	const container = $('html, body');

	form.find('[required]').on('invalid', function () {
		var windowHeight = $(window).height();
		var windowQuarter = windowHeight / 5;
		var invalidDistTop = form.find('input:invalid, textarea:invalid, select:invalid').first().offset().top - windowQuarter;

		if (invalidDistTop > window.pageYOffset && invalidDistTop < (window.pageYOffset + windowHeight - windowQuarter)) {
			return true;
		} else {
			container.scrollTop(invalidDistTop);
		}
	});
}
